import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
  AbcDateBoxComponent,
  AbcDropDownBoxComponent,
  AbcNumberBoxComponent,
  AbcTextBoxComponent,
  _AbcCheckBoxComponent,
  _AbcGridComponent,
  _AbcSelectBoxComponent,
  _AbcTextAreaComponent,
} from '@barthauer/abc/ui-components';
import { ValuesEditorComponent } from './values-editor.component';

@NgModule({
  declarations: [ValuesEditorComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    AbcTextBoxComponent,
    _AbcCheckBoxComponent,
    AbcDateBoxComponent,
    AbcNumberBoxComponent,
    _AbcTextAreaComponent,
    AbcDropDownBoxComponent,
    _AbcSelectBoxComponent,
    _AbcGridComponent,
  ],
  exports: [ValuesEditorComponent],
})
export class ParamValuesEditorModule {}
